import React from 'react';
import { AiOutlineHome } from 'react-icons/ai';
import { BiMessageSquareDetail } from 'react-icons/bi';
import { MdOutlineLaptopChromebook } from 'react-icons/md';
import { RxPerson } from 'react-icons/rx';
import './nav.css';

const Nav = ({ activeNav, setActiveNav }) => {
  const handleNavClick = (navId) => {
    setActiveNav(navId);

    // Smooth scroll to the clicked section
    const targetSection = document.querySelector(navId);
    if (targetSection) {
      targetSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav>
      <a
        href="/"
        className={activeNav === '#header' ? 'active' : ''}
        onClick={() => handleNavClick('#header')}
      >
        <AiOutlineHome />
      </a>
      <a
        href="#about"
        className={activeNav === '#about' ? 'active' : ''}
        onClick={() => handleNavClick('#about')}
      >
        <RxPerson />
      </a>
      <a
        href="#experience"
        className={activeNav === '#experience' ? 'active' : ''}
        onClick={() => handleNavClick('#experience')}
      >
        <MdOutlineLaptopChromebook />
      </a>
      <a
        href="#contact"
        className={activeNav === '#contact' ? 'active' : ''}
        onClick={() => handleNavClick('#contact')}
      >
        <BiMessageSquareDetail />
      </a>
    </nav>
  );
};

export default Nav;
